import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: "What's the free trial for email sequencing?",
  answer: 'Every new account gets free credits to test our email sequence software before committing to a paid plan. Find local business leads, build B2B email sequences, and launch outreach — all at no cost. <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" class="text-blue-600 font-semibold hover:underline">Sign up for free →</a>'
}, {
  question: 'Is Openmart an email sequence software or a data provider?',
  answer: 'Both! Openmart is the best email sequence software for sales teams because it comes pre-loaded with a database of 200M+ local businesses. You find the leads and launch B2B email sequences all from one platform — no need for separate tools.'
}, {
  question: 'Does it integrate with my CRM?',
  answer: 'Yes. Openmart acts as an email sequence CRM that natively syncs with Salesforce and HubSpot. It automatically logs CRM sequences emails calls so your system of record is always up to date.'
}, {
  question: 'Can I replace my HubSpot email sequences with this?',
  answer: 'Absolutely. Many teams use Openmart to replace expensive add-ons for HubSpot email sequences or tools like Outreach/Salesloft, specifically when targeting local businesses and brick-and-mortar shops.'
}, {
  question: 'How do you ensure high email deliverability?',
  answer: 'Our email sequence tools include built-in email validation for all owner contacts. We also support custom tracking domains, sender rotation, and gradual ramp-up to protect your domain reputation.'
}, {
  question: 'Can I personalize the automated emails?',
  answer: 'Yes, you can use any data point from our local business database (like company name, location, tech stack, or estimated revenue) as a dynamic variable in your B2B email sequence to increase reply rates.'
}];
export function SequenceFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 bg-slate-50" data-id="element-1498">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1499">
        <div className="text-center mb-10" data-id="element-1500">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-1501">
            Frequently asked <span className="text-blue-600" data-id="element-1502">questions</span>
          </h2>
        </div>

        <div className="space-y-0 divide-y divide-slate-200" data-id="element-1503">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="py-4" data-id="element-1504">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left flex justify-between items-center focus:outline-none group" aria-expanded={isOpen} data-id="element-1505">
                  <span className={`text-base font-semibold transition-colors pr-8 ${isOpen ? 'text-blue-600' : 'text-slate-900 group-hover:text-blue-600'}`} data-id="element-1506">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'transform rotate-180 text-blue-600' : 'text-slate-400 group-hover:text-blue-600'}`} data-id="element-1507" />
                </button>
                <AnimatePresence data-id="element-1508">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-1509">
                      <div className="pt-3 pb-1 text-sm text-slate-600 leading-relaxed" dangerouslySetInnerHTML={{
                  __html: faq.answer
                }} data-id="element-1510" />
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}